<header class="app-header">
  <div class="header-left">
    <button class="menu-btn" (click)="toggleSidebar()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M3 12h18M3 6h18M3 18h18" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <a href="">
      <div class="logo-container">
        <img [src]="currentLogo" [alt]="currentTenantName" class="logo" />
      </div>
    </a>
  </div>

  <div class="actions-container d-flex align-items-center gap-3">
    <button
      mat-icon-button
      (click)="toggleTheme()"
      class="theme-toggle"
      [matTooltip]="isDarkMode ? 'Mudar para modo claro' : 'Mudar para modo escuro'"
    >
      <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <div class="lang-switcher">
      <button
        (click)="toggleLanguage()"
        class="lang-btn"
        [matTooltip]="translate.currentLang === 'en' ? 'Switch to Portuguese' : 'Mudar para Inglês'"
      >
        <img
          [src]="
            translate.currentLang === 'en'
              ? 'https://flagcdn.com/24x18/us.png'
              : 'https://flagcdn.com/24x18/br.png'
          "
          [alt]="translate.currentLang === 'en' ? 'English' : 'Português'"
        />
      </button>
    </div>

    <!-- <button mat-icon-button class="help-btn" [matTooltip]="'HEADER.USER_MENU.HELP' | translate">
      <mat-icon>help_outline</mat-icon>
    </button> -->

    <app-notifications-panel></app-notifications-panel>

    <div class="user-menu-container">
      <div
        class="user-profile-card"
        (click)="toggleMenu(); $event.stopPropagation()"
        [class.active]="isMenuOpen"
      >
        <div class="user-avatar" [class.has-image]="!!profileImageUrl">
          @if (profileImageUrl) {
            <img [src]="profileImageUrl" [alt]="userName" />
          } @else {
            <mat-icon>person</mat-icon>
          }
        </div>
        <div class="user-info d-none d-md-block">
          <div class="user-name-row">
            <span class="name">{{ userName }}</span>
          </div>
          <div class="user-role-badge">{{ userBadge }}</div>
        </div>
        <mat-icon class="chevron-icon">expand_more</mat-icon>
      </div>

      @if (isMenuOpen) {
        <div class="dropdown-menu">
          <a class="dropdown-item" (click)="openProfileModal()">
            <mat-icon>account_circle</mat-icon>
            <span>{{ 'HEADER.USER_MENU.MY_PROFILE' | translate }}</span>
          </a>
          <a class="dropdown-item" href="javascript:void(0)">
            <mat-icon>settings</mat-icon>
            <span>{{ 'HEADER.USER_MENU.SETTINGS' | translate }}</span>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item logout" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ 'HEADER.USER_MENU.LOGOUT' | translate }}</span>
          </a>
        </div>
      }
    </div>
  </div>
</header>
